import { Dispatch, useCallback } from "react";
import {
  DepoimentosActions,
  DepoimentosActionUnion,
} from "./Depoimentos.Actions";
import DepoimentosService from "../../Data/Services/DepoimentosService";
import { IDepoimentosEffects } from "./Interfaces/IDepoimentosEffects";
import { IResponse } from "../../Data/Interfaces/Base/IResponse";
import { IViaCepResponse } from "../../Data/Interfaces/Responses/ViaCep/IViaCepResponse";
import ViaCepService from "../../Data/Services/ViaCepService";
import { IResponseDepoimentos } from "../../Data/Interfaces/Responses/Depoimentos/IResponseDepoimentos";

export type DepoimentosEffectsType = (
  dispatch: Dispatch<DepoimentosActionUnion>
) => IDepoimentosEffects;

export const DepoimentosEffects: DepoimentosEffectsType = (
  dispatch: Dispatch<DepoimentosActionUnion>
) => ({
  getDepoimentos: useCallback(async () => {
    try {
      dispatch(DepoimentosActions.setLoading(true));
      const { data } = await DepoimentosService.fetchDepoimentos();
      const result = data as IResponse<IResponseDepoimentos[]>;

      window.setInterval(function () {
        dispatch(DepoimentosActions.nextDepoimento());
      }, 7000);
      dispatch(DepoimentosActions.saveDepoimentossSuccess(result));
    } catch (err: any) {
      dispatch(DepoimentosActions.saveDepoimentossFailed(err));
    } finally {
      dispatch(DepoimentosActions.setLoading(false));
    }
  }, [dispatch]),
});
